import React from "react";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts";

interface DoughnutChartProps {
  data: {
    totalPeopleCount: number;
    visitorCount: number;
    staffCount: number;
  };
  color: string[];
  centerLabel: {
    title: string;
    unit: string;
  };
  seriesConfig: {
    name: string;
    dataField: string;
  }[];
  seriesName?: string;
  radius?: [string, string];
}

const DoughnutChart: React.FC<DoughnutChartProps> = ({
  data,
  color,
  centerLabel,
  seriesConfig,
  seriesName,
  radius,
}) => {
  const option = {
    tooltip: {
      trigger: "item",
    },
    series: [
      {
        name: seriesName,
        type: "pie",
        radius: radius,
        avoidLabelOverlap: false,
        label: {
          position: "center",
          formatter: `{title|${centerLabel.title}}\n{number|${data?.totalPeopleCount}}\n{unit|${centerLabel.unit}}`,
          rich: {
            title: { fontSize: 25, color: "#000", lineHeight: 5 },
            number: {
              fontSize: 45,
              color: "#000",
              lineHeight: 78,
            },
            unit: { fontSize: 25, color: "#000", lineHeight: 5 },
          },
          fontSize: 20,
          fontWeight: "bold",
          color: "#000",
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 40,
            fontWeight: "bold",
          },
        },
        labelLine: {
          show: false,
        },
        data: seriesConfig.map((config, index) => ({
          value: data?.[config.dataField as keyof typeof data],
          name: config.name,
          itemStyle: { color: color[index] },
        })),
      },
    ],
  };
  return (
    <ReactECharts
      option={option}
      echarts={echarts}
      style={{
        height: "100%",
        width: "100%",
        backgroundColor: "#F8F8F8",
        borderRadius: 15,
      }}
    />
  );
};

export default DoughnutChart;
